'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Check if this is a harmless RSC streaming error or empty error
  if (!error.message || error.message === '' || error.message.includes('Connection closed')) {
    console.warn('[Global Error Boundary] Suppressing harmless/empty error');
    // For global errors, we need to force a page reload
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
    return null;
  }
  
  console.error('Global error:', error);
  
  return (
    <html>
      <body>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '100vh',
          fontFamily: 'system-ui, sans-serif',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>
            Application Error
          </h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            {error.message || 'An unexpected error occurred'}
          </p>
          <button
            onClick={() => {
              // Clear storage and reset
              localStorage.clear();
              sessionStorage.clear();
              reset();
            }}
            style={{
              padding: '10px 20px',
              background: '#000',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Reload Application
          </button>
        </div>
      </body>
    </html>
  );
} 